import { DependencyList, EffectCallback, useEffect } from "react";

/**
 * Prevents double call issue in development
 * @param {*} callback
 * @param {*} deps
 */
export const useEffectSafe = (callback: EffectCallback, deps: DependencyList) => {
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            callback();
        }, 200);
        return () => {
            clearTimeout(timeoutId);
        };
    }, deps);
};